// extracted by mini-css-extract-plugin
export default {"card":"b2-z"};